import { apiRequest } from '@/utils/request'

// 添加授权申请
export function startOnliePay(data) {
  return apiRequest({
    url: '/BusinessDirect/WeChatInitiateQrCodePay',
    method: 'post',
    data: data
  })
}

// 根据业务号获取缴费信息
export function GetWaitPaymentOfflineOrder(queryParams) {
  return apiRequest({
    url: 'BusinessDirect/GetWaitPaymentOfflineOrder',
    method: 'get',
    params: queryParams
  })
}